import { Fragment, createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { GuardedView, ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const ProductObservationsPage = lazy(() =>
  import('./pages/ProductObservationsPage').then((module) => ({
    default: module.ProductObservationsPage,
  })),
);

const WarehouseProductObservationsPage = lazy(() =>
  import('./pages/WarehouseProductObservationsPage').then((module) => ({
    default: module.WarehouseProductObservationsPage,
  })),
);

const ProductObservationDetailPage = lazy(() =>
  import('./pages/ProductObservationDetailPage').then((module) => ({
    default: module.ProductObservationDetailPage,
  })),
);

const DestructionBlockPage = lazy(() =>
  import('./pages/DestructionBlockPage').then((module) => ({
    default: module.DestructionBlockPage,
  })),
);

const UnspscGuidePage = lazy(() =>
  import('./pages/UnspscGuidePage').then((module) => ({
    default: module.UnspscGuidePage,
  })),
);

/**
 * Gating:
 * - the creation screen and its history tab require `add_productobservation`;
 * - the bandeja and the detail are the shared views: reachable with either the
 *   own-site permission or the whole-history one.
 */
export const productObservationsRoutes: RouteObject[] = [
  {
    path: 'productos-observados',
    element: createElement(ProtectedRoute),
    children: [
      {
        // The page is the parent of the `index`/`historial` markers on purpose:
        // it stays mounted across both URLs, so a form in progress survives a
        // trip to the history tab.
        element: createElement(GuardedView, {
          view: 'productObservations',
          children: createElement(ProductObservationsPage),
        }),
        // The markers only register the URLs; the page itself never renders an
        // Outlet. Give them an empty element so React Router does not warn
        // about element-less leaf routes.
        children: [
          { index: true, element: createElement(Fragment) },
          { path: 'historial', element: createElement(Fragment) },
        ],
      },
      {
        path: 'almacen',
        element: createElement(GuardedView, {
          view: 'warehouseProductObservations',
          children: createElement(WarehouseProductObservationsPage),
        }),
      },
      {
        path: 'bloques/:blockCode',
        element: createElement(GuardedView, {
          view: 'destructionBlock',
          children: createElement(DestructionBlockPage),
        }),
      },
      {
        path: ':id',
        element: createElement(GuardedView, {
          view: 'productObservationDetail',
          children: createElement(ProductObservationDetailPage),
        }),
      },
    ],
  },
  {
    path: 'desmedro/guia-unspsc',
    element: createElement(ProtectedRoute, { view: 'unspscGuide' }),
    children: [{ index: true, element: createElement(UnspscGuidePage) }],
  },
];
